import { graphql } from "api/cms-website/generated";

import { TabbedContentTabItemFragment } from "./tabbedContentTabItem";

export const TabbedContentTabFragment = graphql(/* GraphQL */ `
    fragment TabbedContentTabFragment on ComponentElementsTabbedContentTab {
        id
        title
        subtitle
        content(pagination: { limit: 100 }) {
            ...TabbedContentTabItemFragment
        }
    }
    ${TabbedContentTabItemFragment}
`);
